// 직분 한글 변환
export const POSITION_MAP = {
  pastor: '목사',
  evangelist: '전도사',
  elder: '장로',
  ordained_deacon: '안수집사',
  kwonsa: '권사',
  deacon: '서리집사',
  youth: '청년',
  member: '성도',
  middle_high_school: '중고등부',
  sunday_school: '교회학교',
};

// 구역활동 한글 변환
export const CELL_GROUP_MAP = {
  youth1: '청년1구역',
  youth2: '청년2구역',
  youth3: '청년3구역',
  women1: '여성1구역',
  women2: '여성2구역',
  men: '남성구역',
};

// 방문목적 한글 변환
export const VISIT_PURPOSE_MAP = {
  work: '직장',
  business: '사업',
  study: '유학',
  travel: '여행',
  other: '기타',
};

// 성별 한글 변환
export const GENDER_MAP = {
  male: '남성',
  female: '여성',
  other: '기타',
};

// 세례 한글 변환
export const BAPTISM_MAP = {
  infant_baptism: '유아세례',
  confirmation: '입교',
  baptism: '세례',
  none: '해당 없음',
};

// 성도구분 한글 변환
export const MEMBER_CLASS_MAP = {
  A: '정회원',
  B: '준회원',
  R: '방문',
};

// 사역팀 한글 변환
export const MINISTRY_TEAM_MAP = {
  praise: '찬양팀',
  service: '봉사팀',
  newcomer: '새신자팀',
  education: '교육팀',
  manna: '만나팀',
  mission: '선교팀',
  media: '미디어팀',
  etc: '기타',
};

// 주차 관련 유틸리티 함수
// 특정 날짜가 속한 주차(월 기준)를 반환 (1-5)
export const getWeekOfMonth = (date: Date): number => {
  const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
  const dayOfWeek = firstDayOfMonth.getDay(); // 0 (일요일) ~ 6 (토요일)
  
  // 첫 주가 일요일로 시작하지 않을 경우를 고려
  const startOffset = dayOfWeek === 0 ? 0 : dayOfWeek; // 일요일이면 0, 아니면 요일 값
  const daysFromFirstDay = date.getDate() - 1 + startOffset;
  
  return Math.ceil(daysFromFirstDay / 7);
};

// 특정 날짜가 속한 연도와 주차(ISO 주차 기준)를 반환
export const getYearAndWeekFromDate = (date: Date): { year: number; week: number } => {
  const tempDate = new Date(date.getTime());
  tempDate.setDate(tempDate.getDate() - tempDate.getDay() + (tempDate.getDay() === 0 ? -6 : 1)); // 월요일을 주의 시작으로 설정
  const year = tempDate.getFullYear();
  const startOfYear = new Date(year, 0, 1);
  const days = Math.floor((tempDate.getTime() - startOfYear.getTime()) / (24 * 60 * 60 * 1000));
  const week = Math.ceil((days + startOfYear.getDay() + 1) / 7); // ISO 주차 계산

  return { year, week };
};

// 특정 연도와 주차에 해당하는 주의 시작일(월요일)과 종료일(일요일)을 반환
export const getWeekDates = (year: number, week: number): { startDate: string; endDate: string } => {
  const firstDayOfYear = new Date(year, 0, 1);
  // 첫 주가 월요일로 시작하도록 조정
  const daysOffset = (week - 1) * 7;
  const startDate = new Date(firstDayOfYear);
  startDate.setDate(startDate.getDate() + daysOffset - (firstDayOfYear.getDay() === 0 ? 6 : firstDayOfYear.getDay() - 1));
  
  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + 6);

  return {
    startDate: startDate.toISOString().split('T')[0],
    endDate: endDate.toISOString().split('T')[0],
  };
};
